<template>
  <div class="container">
    <label for="orderBevestigingStatussen" class="form-label mb-1">Filter</label>
    <div v-for="status in orderBevestigingStatussen" :key="status.id" class="form-check form-switch">
      <input class="form-check-input"
             @change="filterStatusChanged()"
             type="checkbox"
             v-model="filter.status[status.id]"
             :id="status.id">
      <label class="form-check-label label-text" :for="`status_${status.id}`">
        &nbsp;<i class="bi bi-circle-fill close" :class="getColor(status.id)"></i>&nbsp;{{ status.label }}
      </label>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/Utils"
import { watch } from 'vue'
var capitalize = require('lodash/capitalize');
import localDB from '../utils/localDB';

export default {
  name: 'FilterOrderBevestiging',
  props: {
    orderBevestigingStatussen: Array
  },
  emits: ['filterStatusChanged'],
  inject: ['isAdmin'],
  data() {
    return {
      orderService: null,
      filter: {
        status: {},
        customer: {}
      },
      customerOptions: {
        sabic: 'Sabic',
        tata: 'Tata',
        esso: 'Esso',
        huntsman: 'Huntsman',
        cabot: 'Cabot',
        mccain: 'McCain',
      },
      selectedCustomer: "Geen selectie",
      dropdownOpen: false,
      showAdvancedFilters: false,
      activeAdvancedFilters: false,
    }
  },
  watch: {
    orderBevestigingStatussen: {
      handler: function (val) {
        if (val) {
          val.forEach(status => {
            this.filter.status[status.id] = false;
          });
        }
      },
      deep: true
    }
  },
  methods: {
    getColor(status) {
      return Utils.getColorForOrderConfirmationStatus(status)
    },
    filterStatusChanged() {
      this.activeAdvancedFilters = Object.values(this.filter.customer).filter(active => active).length > 0;
      this.updateSelectedCustomerString()
      this.$emit('filterStatusChanged', this.filter)
    },
    updateSelectedCustomerString(){
      this.selectedCustomer = ""
      for(let customer in this.filter.customer) {
        let customerSelected = this.filter.customer[customer]
        if(customerSelected){
          this.selectedCustomer += `${capitalize(customer)}, `
        }
      }
      if(this.selectedCustomer.length > 0) {
        this.selectedCustomer = this.selectedCustomer.slice(0, -2)
      }else{
        this.selectedCustomer = "Geen selectie"
      }
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    toggleAdvancedFilters() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
  },
  async mounted() {
    const storedFilter = await localDB.getItem('orderBevestigingFilter');
    if (storedFilter) {
      this.filter = JSON.parse(storedFilter);
      this.updateSelectedCustomerString()
    }
    
    watch(() => this.filter, async (newValue) => {
      await localDB.setItem('orderBevestigingFilter', JSON.stringify(newValue));
    }, { deep: true });
  }
}
</script>

<style scoped>
.form-check-input {
  position: relative;
  top: -2px;
}
.form-check {
  display: flex;
  align-items: center;
}
.label-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
  display: inline-block;
}
.rounded-input {
  border-radius: 8px;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
}
</style>